export default __webpack_public_path__ + "static/logo-veerman-ict-851ab5959cf40ee21b2c4abbda220582.png";